// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconArrowDown.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconArrowDown = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 9" fill="currentColor" { ...props }>
    <path d="M0.252653 0.258689C-0.0842178 0.603608 -0.0842178 1.16278 0.252653 1.5077L7.31743 8.74131C7.50435 8.93269 7.75571 9.01785 8 8.9969C8.24429 9.01785 8.49565 8.93269 8.68257 8.74131L15.7473 1.5077C16.0842 1.16278 16.0842 0.603608 15.7473 0.258689C15.4105 -0.0862297 14.8643 -0.0862297 14.5274 0.258689L8 6.94203L1.47257 0.258689C1.1357 -0.0862297 0.589524 -0.0862297 0.252653 0.258689Z" />
  </BaseIcon>
);

export default IconArrowDown;
